import React from "react";

import "./Toast.css";

import { connect } from "react-redux";
import * as actions from "../../store/actions";

import { IconButton } from "@mui/material";
import CrossIcon from "@mui/icons-material/Clear";

const Toast = (props) => {
  return <>
    <div className={`notification-container top-right`}>
      {props.toasts.map((toast, i) => (
        <div key={i} className={`notification toast ${toast.status}`}>
          <div className={"body"}>
            {/* <div className={"left"}>
              <div className="notification-image">
                <img src={toast.icon} alt="" />
              </div>
            </div> */}
            <div className={"center-container-toast"}>
              <h4 className="notification-title">{toast.title}</h4>
              <p className="notification-message">{toast.message}</p>
            </div>
            <div className={"right-container-toast"}>
              <IconButton onClick={() => props.removeNotification(toast.id)} size="large">
                <CrossIcon className="crossIcon" />
              </IconButton>
            </div>
          </div>
        </div>
      ))}
    </div>
  </>;
};

const mapStateToProps = (state) => {
  return {
    toasts: state.notifications.toasts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeNotification: (id) => dispatch(actions.removeNotification(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Toast);
